import { useZero as useZeroBase } from "@rocicorp/zero/react";
import type { schema, Mutators } from "@lovd/zero-schema";

/** Pre-typed wrapper so call sites don't repeat the generic signature. */
export function useZero() {
  return useZeroBase<typeof schema, Mutators>();
}
